import './AgentReply.css'
import { useEffect } from 'react'
import type { AgentWidget } from 'aevocam-rest-api-spec'
import { MarkdownViewer } from '@/components/scalar/MarkdownViewer'
import { AgentWidgetView } from './AgentWidgetView'
import { widgetHasVisibleUi } from './widgetVisibility'

type Props = {
  content: string
  widgets?: AgentWidget[]
  reasoning?: string
  /** True when widgets just arrived from the live stream for this turn */
  fromStream?: boolean
  onStreamConsumed?: () => void
  setArticleIds?: (articleIds?: string[]) => void
  onRefreshEditor?: () => void
}

export function AgentReply({
  content,
  widgets,
  reasoning,
  fromStream,
  onStreamConsumed,
  setArticleIds,
  onRefreshEditor,
}: Props) {

  useEffect(() => {
    if (!fromStream) return
    onStreamConsumed?.()
  }, [fromStream]) // onStreamConsumed intentionally omitted — one-shot clear

  const visibleWidgets = widgets?.filter(widgetHasVisibleUi) ?? []
  const invisibleWidgets = widgets?.filter(widget => !widgetHasVisibleUi(widget)) ?? []

  return (
    <div className='AgentReply'>
      {reasoning && reasoning.length > 0 && (
        <div className='Reasoning'>
          {reasoning}
        </div>
      )}
      <MarkdownViewer value={content} />
      {invisibleWidgets.map((widget, index) => (
        <AgentWidgetView
          key={`action-${widget.placeholder}-${index}`}
          widget={widget}
          fromStream={fromStream}
          onRefreshEditor={onRefreshEditor}
        />
      ))}
      {visibleWidgets.length > 0 && (
        <div className='Widgets'>
          {visibleWidgets.map((widget, index) => (
            <div
              key={`${widget.placeholder}-${index}`}
              className='Widget'
            >
              <AgentWidgetView
                widget={widget}
                fromStream={fromStream}
                setArticleIds={setArticleIds}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
